<template>
    <div>
        <v-container grid-list-lg>
            <p class="display-1">{{ 'My wishlist' | translation }}</p>
            <template v-if="Object.keys(products).length === 0">
                <p class="title">{{ 'You have no products on your wishlist.' | translation }}</p>
            </template>
            <template v-else>
                <v-layout row wrap v-if="loaded">
                    <v-flex
                        xs12
                        sm6
                        md3
                        v-for="product in products"
                        :key="product.id"
                    >
                        <product-thumbnail :product="product" target="Wishlist"/>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-else>
                    <v-flex
                        xs12
                        sm6
                        md3
                        v-for="n in [1, 2, 3, 4]"
                        :key="n"
                    >
                        <content-loader :height="515" :width="278" :speed="3" primaryColor="#f1f1f1" secondaryColor="#e3e3e3">
                            <rect x="0" y="0" rx="0" ry="0" width="278" height="278" />
                            <rect x="20" y="305" rx="0" ry="0" width="238" height="20" />
                            <rect x="20" y="335" rx="0" ry="0" width="238" height="10" />
                            <rect x="20" y="355" rx="0" ry="0" width="238" height="10" />
                            <rect x="20" y="375" rx="0" ry="0" width="238" height="10" />
                            <rect x="165" y="430" rx="0" ry="0" width="93" height="30" />
                        </content-loader>
                    </v-flex>
                </v-layout>
            </template>
        </v-container>
    </div>
</template>

<script>
import Vue from 'vue';
import {mapState, mapGetters, mapMutations} from 'vuex';
import {getProducts} from '@breakmedia/prime-vue-product/src/store/getProducts';
import {Observable} from 'rxjs';

const moduleName = 'Wishlist';

export default {
    name: moduleName,
    data() {
        return {
            loaded: false,
            productsSubscriber: null,
        };
    },
    created() {
        this.productsSubscriber = getProducts(new Observable(
            subscriber => this.$watch('productIds', ids => subscriber.next({ids}), {immediate: true})
        )).subscribe(products => {
            this.loaded = true;
            this.setProducts(products);
        });
    },
    beforeDestroy() {
        this.productsSubscriber.unsubscribe();
    },
    computed: {
        ...mapState(moduleName, [
            'products',
        ]),
        ...mapGetters('Login', ['isUserLoggedIn']),
        productIds() {
            if (this.isUserLoggedIn) {
                return Vue.$wishlist.getIds();
            } else {
                this.setShowLoginModal(true);
                return [];
            }
        },
    },
    methods: {
        ...mapMutations(moduleName, [
            'setProducts',
        ]),
        ...mapMutations('Login', ['setShowLoginModal']),
    },
};
</script>
